/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Picture from '@nmx/template/dist/componentLibrary/components/Picture';
// nm2024 themed components
import { BulletedListNm2024 } from '../../../../nm2024Theme/components/bulletedList/styles';
import { LinkNm2024 } from '../../../../nm2024Theme/components/link/styles';
import { SectionContainerNm2024  } from '../../../../nm2024Theme/components/sectionContainer/styles';
import { TypographyNm2024  } from '../../../../nm2024Theme/components/typography/styles';
// NM 2024 theme
import Nm2024Theme from '../../../../nm2024Theme/nm2024Theme/colors';

export const BulletedListStyled = styled(BulletedListNm2024)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    const smallUp = theme.smallUp();
    let thisMargin = 0;
    const horizontalPadding = rem(6);

    if(mediumUp){
      thisMargin = 'auto';
    }else if(smallUp){
      thisMargin = '0 5%';
    }

    return css`
      margin: ${thisMargin};
      padding-bottom: ${rem(28)};
      ${mediumUp && 'width: fit-content;'}
      .nmx-icon {
        height: ${rem(25)};
        width: ${rem(25)};
        background-color: ${Nm2024Theme.navy.navy};
        border-radius: 50%;
        padding-left: ${horizontalPadding};
        padding-right: ${horizontalPadding};
        top: ${rem(1)};
        .icon-fill {
          fill: ${theme.colors.neutral.white};
        }
      }
    `;
  }
}`;

export const ColStyled = styled(Col)`
  ${({ theme }) => {
    const xlargeUp = theme.xlargeUp();
    const largeUp = theme.largeUp();
    const mediumUp = theme.mediumUp();
    const smallUp = theme.smallUp();
    let horizontalPadding = rem(70);

    if(xlargeUp){
      horizontalPadding = rem(100);
    }else if(largeUp){
      horizontalPadding = rem(90);
    } else if(mediumUp){
      horizontalPadding = rem(40);
    } else if(smallUp){
      horizontalPadding = rem(120);
    }

    return css`
      padding-left: ${horizontalPadding};
      padding-right: ${horizontalPadding};
      padding-bottom: ${mediumUp ? 0 : rem(24)};
    `;
  }
}`;

export const LinkStyledButton = styled(LinkNm2024)`
  ${({ theme }) => {
    const mediumDown = theme.mediumDown();
    const smallDown = theme.smallDown();
    return css`
      display: flex;
      ${mediumDown && 'margin: 0 auto;'}
      ${smallDown && `
        width: 100%;
        max-width: none;
      `}
    `;
  }
}`;

export const PictureStyled = styled(Picture)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      max-width: ${mediumUp ? rem(375) : rem(160)};
      margin: 0 auto;
    `;
  }}
`;

export const SectionContainerStyled = styled(SectionContainerNm2024 )`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    const verticalPadding = mediumUp ? rem(52) : rem(48);
    return css`
      padding-top: ${verticalPadding};
      padding-bottom: ${verticalPadding};
    `;
  }
}`;

export const TypographyStyledHeading = styled(TypographyNm2024)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      && {
        padding-bottom: ${mediumUp ? rem(40) : rem(12)};
      }
    `;
  }
}`;
